module.exports = __webpack_public_path__ + "static/media/08.aa79e0fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/08.jpg
// module id = 183
// module chunks = 0